<template>
  <div>
    <nav class="navbar">
      <div class="navbar-brand">
        <a class="navbar-item" href="https://melta.co.jp">
          <img src="@/assets/logo.png" alt="メルタ">
        </a>
      </div>
    </nav>
    <header class="hero is-success is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">体積計算</h1>
        </div>
      </div>
    </header>
    <main>
      <div class="section">
        <div class="columns is-centered" v-if="!mobile">
          <div class="column is-four-fifths">
            <div class="container">
              <div class="columns">
                <div class="column is-three-fifths viewer">
                  <Viewer />
                </div>
                <div class="column is-two-fifths calc">
                  <Calculator />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-centered" v-else>
          <div class="column is-four-fifths">
            <div class="container">
              <article class="message">
                <div class="message-body">
                  PCからこのページにアクセスすると、自動お見積もり機能がご利用いただけます。
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
      
    </main>
  </div>
</template>

<script>
import Viewer from "./components/Viewer";
import Calculator from "./components/Calculator";
import isMobile from 'ismobilejs'

export default {
  components: { 
    Viewer,
    Calculator,
  },
  computed: {
    mobile() {
      return (isMobile().any)
    }
  }
}
</script>
